package co.maytes.standupbot.dashboard.components.motion

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.styles.Marketing
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.Element

enum class RevealStyle(val classNames: List<String>) {
    Rise(listOf(Marketing.REVEAL_CLASS)),
    Scale(listOf(Marketing.REVEAL_CLASS, Marketing.REVEAL_SCALE_CLASS)),
    Trigger(emptyList()),
}

@Composable
fun Reveal(
    index: Int = 0,
    style: RevealStyle = RevealStyle.Rise,
    threshold: Double = Marketing.REVEAL_THRESHOLD,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
) {
    var shown by remember { mutableStateOf(false) }
    Div(
        attrs = modifier
            .classNames(*style.classNames.toTypedArray())
            .let { if (shown) it.classNames(Marketing.REVEAL_IN_CLASS) else it }
            .styleModifier { property(Marketing.INDEX_VAR, "$index") }
            .toAttrs {
                if (!shown) {
                    ref { element ->
                        val stop = observeOnce(element, threshold) { shown = true }
                        onDispose { stop() }
                    }
                }
            },
        content = { content() },
    )
}

fun observeOnce(target: Element, threshold: Double, onVisible: () -> Unit): () -> Unit {
    val window = kotlinx.browser.window.asDynamic()
    if (window.IntersectionObserver == undefined) {
        onVisible()
        return {}
    }
    val callback: (dynamic, dynamic) -> Unit = { entries, observer ->
        val first = entries[0]
        if (first != null && first.isIntersecting == true) {
            onVisible()
            observer.disconnect()
        }
    }
    val options = js("({})")
    options.threshold = threshold
    val observer = js("new window.IntersectionObserver(callback, options)")
    observer.observe(target)
    return { observer.disconnect() }
}
